import React, { useRef, useState } from 'react';
import PrimaryModal from '../../UI/Modal/PrimaryModal';
import { PrimaryButton } from "../../UI";
import { saveEntityData } from '../../../utils/APIs';
import { useUserContext } from '../../../contexts/UserContext';
import { convertCSVToJson } from '../../../utils/converter';
import Loader from '../../UI/Loader/Loader';
import SuccessAlert from '../../UI/Alert/SuccessAlert';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const AddEntityModal = ({ showAddEntityModal, handleCloseModal }) => {
    const fileInputRef = useRef('');
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

    const [error, setError] = useState("")
    const [formattedData, setFormattedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState();

    const handleCSVData = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();    
        reader.onload = (event) => {
            const text = event.target.result;
            const rows = text.split('\n').map(row => row.split(','));

            const updatedData = convertCSVToJson(rows, "save_entity", content.ADD_ENTITY_CSV_MAPPING)
            setFormattedData(updatedData)
        };
        reader.readAsText(file);
    };

    const handleSubmit =async () => {
        try {
            setLoading(true);
             await saveEntityData(
                userData?.token,
                userData?.selectedOrganization?.org_token,
                userData?.defaultAdobeIO?.tenant_name,
                { entities: formattedData } 
            );
            setError("")
            setSuccess(true)
            handleClose()
        } catch (error) {
            console.log("error handleSubmit: ", error);
            setError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg)
        } finally {
            setLoading(false);
        }
    }

    const handleClose = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        handleCloseModal()
    }

    return (
        <>
            {success && <SuccessAlert disappearTime={content.LIST_ENTITIES_CONTENT.add_entity_modal.success_timeout} >{content.LIST_ENTITIES_CONTENT.add_entity_modal.success}</SuccessAlert> }
            {showAddEntityModal && <PrimaryModal title={content.LIST_ENTITIES_CONTENT.add_entity_modal.title} hideModal={handleClose}>
                {loading && <Loader />}
                <div className='p-6 space-y-6'>
                    <p className='text-base leading-tight tracking-tight text-black mb-4'>{content.LIST_ENTITIES_CONTENT.add_entity_modal.description}</p>

                    <input type="file" ref={fileInputRef} onChange={handleCSVData}/>
                    <p className="mt-2 text-sm text-red-5">{error}</p>

                    <div className="flex items-center justify-end space-x-2">
                        <PrimaryButton handleClick={handleSubmit} >{content.LIST_ENTITIES_CONTENT.add_entity_modal.add_btn}</PrimaryButton>
                    </div>
                </div>
            </PrimaryModal> }
        </>
    )
}

export default AddEntityModal;
